import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ElementRef,
} from "@angular/core";
import { ClientService } from "../../../_services/client.service";
import { PlaceService } from "../../../_services/place.service";
import { SecurityService } from "../../../_services/security.service";

declare var jQuery: any;

import "../../../../assets/semantic/semantic.min.js";
import { FormArray, FormGroup, FormBuilder, FormControl, Validators } from "@angular/forms";
import { IMyDpOptions } from "mydatepicker";
import { FromObservable } from "rxjs/observable/FromObservable";
import { WarehouseAutocompleteComponent } from "../../warehouse-autocomplete/warehouse-autocomplete.component";


@Component({
  selector: "app-client-new-planning",
  templateUrl: "./client-new-planning.component.html",
  styleUrls: ["./client-new-planning.component.css"],
})
  
export class ClientNewPlanningComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  private creating_planning: boolean;
  private errorMessage = "";
  private user;

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "dd/mm/yyyy",
    openSelectorOnInputClick: true,
    editableDateField: false,
  };
  
  palettes: FormGroup;
  new_planning: FormGroup;

  constructor(
    private elRef: ElementRef,
    private service: ClientService,
    private place_service: PlaceService,
    private security: SecurityService,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.new_planning = this.fb.group({
      planning: this.fb.group({
        state: new FormControl(),
        client_id: new FormControl(""),
        transporter_id: new FormControl(""),
        receiver_id: new FormControl(),
        destinataire_client: new FormControl(),
        departure_id: new FormControl("", [Validators.required]),
        arrival_id: new FormControl("", [Validators.required]),
        planning_palettes: this.fb.array([]),
        ref_client: new FormControl(),
        ref_loading: new FormControl(),
        ref_delivery: new FormControl(),
        vehicle: new FormControl("", [Validators.required]),
        quantity: new FormControl("", [Validators.required]),
        departure_date: new FormControl("", [Validators.required]),
        arrival_date: new FormControl(),
        loading_hour: new FormControl(),
        loading_place: new FormControl(),
        shipping_place: new FormControl(),
        shipping_hour: new FormControl(),
        note: new FormControl(),
        ref_client_interne: new FormControl(),
        client_infos: new FormControl(),
        buy_price: new FormControl(""),
        single_buy_price: new FormControl(""),
        sell_price: new FormControl(""),
        single_sell_price: new FormControl(""),
      })
    });

  }
  get itemsFormArray(): FormArray {
    return this.new_planning.get('planning.planning_palettes') as FormArray;
  }

  addItem(): void {
    if (this.itemsFormArray.length < 4) {
      const item = this.fb.group({
        warehouse_id: '',
        chargees: '',
        type: '',
        rendues: '',
        livrees: '',
        reprises:'',
        warehouse_shipping_id:''
      });

      this.itemsFormArray.push(item);
    }
  }

  removeItem(index: number): void {
    this.itemsFormArray.removeAt(index);
  }

  openModal(field_object: { field; value }) {
    if (field_object) {
      if (field_object.field == "departure_id")
        this.new_planning.patchValue({ departure_id: field_object.value });
      if (field_object.field == "arrival_id")
        this.new_planning.patchValue({ arrival_id: field_object.value });
    }

    jQuery("#add-planning-modal").modal({ inverted: true }).modal("show");
    jQuery(".ui.radio.checkbox").checkbox("uncheck");
  }

  async submitPlanningForm() {
    this.new_planning.disable();
    this.creating_planning = true; // Disable the loading button apparition
    jQuery("#add-planning-modal").modal({ closable: false });

    if (
      this.new_planning.value.planning.departure_date &&
      this.new_planning.value.planning.departure_date.formatted
    ) {

      this.new_planning.get('planning.departure_date').setValue(this.new_planning.value.planning.departure_date.jsdate);
    }
    if (
      this.new_planning.value.planning.arrival_date &&
      this.new_planning.value.planning.arrival_date.formatted
    ) {

      this.new_planning.get('planning.arrival_date').setValue(this.new_planning.value.planning.arrival_date.jsdate);
    }

    // patch value client_id & default state;
    this.user = await this.security.userInfos();
    
    this.new_planning.get('planning.client_id').setValue(this.user.company);
    this.new_planning.get('planning.state').setValue(10);
    
    this.createPlanning();
  }

  createPlanning() {
    this.service
      .createPlanning(this.new_planning.value)
      .subscribe((response) => {
        jQuery("#add-planning-modal").modal({ closable: true }).modal("hide"); // Set the modal closable & Close the modal
        this.creating_planning = false; // Disable the loading button apparition
        this.new_planning.enable(); // Re Enable the Form
        this.new_planning.reset(); // Reset It

        //send mail to geofret
        this.sendNewPlanningMail(response.id);

        jQuery("#add-planning-modal")
          .find(".dropdown")
          .dropdown("set value", "");
        jQuery("#add-planning-modal")
          .find(".dropdown")
          .dropdown("set text", "");
        
        this.refresh.emit(true); // Emmit the refresh Event
      });
  }
//envoi un mail à geofret, à la creation d'un transport par le client
  sendNewPlanningMail(planning_id) {
    this.service.sendNewPlanningMail(planning_id).subscribe((response) => {});
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/client/client-new-planning/client-new-planning.component.ts